var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_c('div',{staticClass:"card__title mt-3"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card__description mt-2"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }